import { useContext, useEffect, useRef, useState } from 'react';
import { QeWrapper } from './style';
import { AlertWrapper, TabContentWrapper } from '../UI/styledConstants';
import { isEmpty, decryptData } from '../../utils/common';
import OfferBanner from '../OfferBanner';
import Loader from '../UI/Loader/Loader';
import IconClose from '../../assets/images/IconClose';
import payIcons from '../../assets/images/paymentsImages.svg';
import pgIcon from '../../assets/images/pg.svg';
import qrIcon from '../../assets/images/qrcodeimg.svg';
import logo from '../../assets/images/favicon.jpeg';

import { QrCkeckStatus, generatePgLink, generateQrcode, openAirpayPg } from '../../utils/api';
import Timer from './Timer';
import { GlobleContaxt } from '../../Context/GlobleContaxt';
import AddMoneyReceipt from './AddmoneyReceipt';
import RadioButtonConfirm from '../UI/RadioButtonConfirm';
import Input from '../UIbox/Input';
import Iframe from './Iframe';

export default function AddMoney({ className = '' }) {
	const [amount, setAmount] = useState('');
	const [email, setEmail] = useState('');
	const [qr, setQr] = useState('');
	const [loading, setLoading] = useState(false);
	const [statusLoading, setStatusLoading] = useState(false);
	const [activeMobilePop, setActiveMobilePop] = useState(false);
	const [timeOver, setTimeover] = useState(false);
	const [timerId, setTimerId] = useState(null);
	const [responce, setResponce] = useState({});
	const [statusResp, setStatusResp] = useState({});
	const [addMoneyType, setAddMoneyType] = useState('');
	const [openIframe, setOpenIframe] = useState(false);
	const [formData, setFormData] = useState(null);

	const [message, setMessage] = useState({});
	const [respMessage, setMessageResp] = useState({});

	const timerRef = useRef(null);
	const formRef = useRef(null);

	const amountReg = /^[0-9]+$/;

	const { setAlert } = useContext(GlobleContaxt);
	const changeHandler = (e) => {
		if (!amountReg.test(e.target.value) && e.target.value) {
			return false;
		} else {
			setAmount(e.target.value);
		}
	};

	const submit = () => {
		if (amount === '' || amount < 10) {
			setAlert({ type: 'info', msg: 'Please enter a minimum of 10 rupees' });
			return;
		} else {
			setQr('');

			const params = {
				amount: amount,
				customerEmail: userDetails?.email,
				customerMobile: userDetails?.userName,
			};
			if (addMoneyType === 'PG') {
				openPg(params);
				return;
			}
			setLoading(true);
			generateQrcode(params).then((resp) => {
				setLoading(false);
				if (resp?.success) {
					setQr(resp?.data?.code);
					setResponce(resp?.data);
					setActiveMobilePop(true);
					checkstatus(resp?.data?.orderId);
					
				} else {
					localStorage.removeItem("pgData");
					setAlert({ type: 'error', msg: resp.msg, place: 'local' });
					setQr('');
					setActiveMobilePop(false);
				}
			});
		}
	};
	useEffect(() => {
		if (!isEmpty(message)) {
			setTimeout(() => {
				setMessage({});
			}, 5000);
		}
	}, [message]);

	useEffect(() => {
		if (timeOver) {
			setAlert({ type: 'info', msg: 'Your payment is pending. Please check your wallet again after some time.', place: 'globle' });
			setQr('');
			setTimeover(false);
			clearTime();
			setActiveMobilePop(false);
		}
		return () => clearTime();
	}, [timeOver]);

	const { userDetails, setRefresh, refresh } = useContext(GlobleContaxt);

	const clearTime = () => {
		if (timerRef.current) {
			clearTimeout(timerRef.current);
		}
		setStatusLoading(false);
	};

	const closePop = () => {
		setActiveMobilePop(false);
		setQr('');
		setResponce({});
		setAmount('');
		setEmail('');
		clearTime();
		setAddMoneyType('');
		setOpenIframe(false);
		localStorage.removeItem("pgData");
	};

	const checkstatus = (order) => {
		setStatusLoading(true);
		timerRef.current = setTimeout(() => {
			QrCkeckStatus(order).then((resp) => {
				if (resp?.success) {
					if (resp?.data.status === 'PENDING') {
						checkstatus(order);
					} else if (resp?.data.status === 'SUCCESS') {
						//setMessageResp({ type: 'success', msg: 'Payment Success', place: '' });
						localStorage.removeItem("pgData");
						setRefresh(!refresh);
						setStatusResp(resp?.data);
						closePop();
						clearTime();
						setLoading(false);
					} else {
						//setMessageResp({ type: 'error', msg: 'Payment Fail', place: '' });
						localStorage.removeItem("pgData");
						setStatusResp(resp?.data);
						closePop();
						clearTime();
						setLoading(false);
					}
				} else {
					setLoading(false);
					let mag = resp?.msg;

					if (resp?.errorCodeList?.length > 0) {
						mag = resp?.errorCodeList[0];
					}
					setAlert({ type: 'error', msg: mag });
				}
			});
		}, 3000);
	};

	const handleOptionChange = (value) => {
		console.log('value', value);
		setAddMoneyType(value);
	};

	const openPg = (param) => {
		setLoading(true);
		openAirpayPg(param).then((resp) => {
			//resp.success
			if (resp?.success) {
				setActiveMobilePop(true);
				
				const responce = resp?.data || {};

				let data = {};
				try {
					const SECRET_KEY =  process.env.REACT_APP_SECRETKEY;
					const decryptedData = decryptData(responce, SECRET_KEY);
					data = JSON.parse(decryptedData);
					console.log("data",data)
					checkstatus(data?.orderId);
					localStorage.setItem("pgData", JSON.stringify({orderId:data?.orderId,type:"addMoney",param:param}));
				} catch (error) {
					localStorage.removeItem("pgData");
					setLoading(false);
					return;
				}
				

				if (formRef.current) {
					const form = formRef.current;
					// setFormData(data)
					// for (const key in data) {
					// 	let newKey = key;
					// 	if (key === 'privateKey') {
					// 		newKey = 'privatekey';
					// 	} else if (key === 'merId') {
					// 		newKey = 'mercid';
					// 	} else if (key === 'orderId') {
					// 		newKey = 'orderid';
					// 	} else if (key === 'isoCurrency') {
					// 		newKey = 'isocurrency';
					// 	}
					// 	const input = form.querySelector(`[name="${newKey}"]`);

					// 	if (input) {
					// 		input.value = data[key];
					// 	}
					// }
					setFormData(data)
					// setOpenIframe(true);
				  setTimeout(() =>{
					form.submit();
				  },100)
				}
			} else {
				setLoading(false);
				setAlert({ type: 'error', msg: resp?.msg, place: 'local' });
				setActiveMobilePop(false);
			}
		});
	};

	return (
		<>
			<TabContentWrapper className={`tab-content-wrapper mobile-recharge-form`}>
				{!isEmpty(message) && message.place === 'globle' && (
					<AlertWrapper className={`${message.type} globle`}>
						<span className="close" onClick={() => setMessage({})}>
							×
						</span>
						{message.msg}
					</AlertWrapper>
				)}
				{!isEmpty(respMessage) && (
					<AlertWrapper style={{ minWidth: '300px' }} className={`${respMessage.type} globle`}>
						<span className="close" onClick={() => setMessageResp({})}>
							×
						</span>
						{respMessage?.msg}
					</AlertWrapper>
				)}
				<div className="tab-content-left">
					<h2>Add Money</h2>
					{isEmpty(addMoneyType) && (
						<div className="form-field">
							<RadioButtonConfirm
								className="mb10"
								heading="Payment gateway"
								label="Add money to wallet using gateway."
								name="addMoneyType"
								checked={addMoneyType === 'PG'}
								error=""
								onClick={handleOptionChange}
								value="PG"
								img={pgIcon}
							/>
							<RadioButtonConfirm
								heading="Show QR"
								label="Scan the QR coe using your UPI app"
								name="addMoneyType"
								checked={addMoneyType === 'QR'}
								error=""
								onClick={handleOptionChange}
								value="QR"
								img={qrIcon}
							/>
						</div>
					)}

					{
						<>
							{addMoneyType && <Input label={'Amount'} name={amount} onChange={(e) => changeHandler(e)} value={amount} required={true} error={''} />}

							{!isEmpty(message) && message.place === 'local' && (
								<AlertWrapper className={`${message.type}`}>
									<span className="close" onClick={() => setMessage({})}>
										×
									</span>
									{message.msg}
								</AlertWrapper>
							)}
							<>
								{addMoneyType && (
									<>
										<button type="submit" className="button-outline" onClick={submit} disabled={statusLoading}>
											Proceed to Pay
										</button>
										<div style={{ fontSize: '10px', cursor: 'pointer', marginTop: '4px' }}>
											{' '}
											<span onClick={() => setAddMoneyType('')}>
												<i class="fa-solid fa-angle-left"></i> Back
											</span>
										</div>
									</>
								)}
							</>
						</>
					}
				</div>

				<div className={`tab-content-right addMoneyOr ${!activeMobilePop ? '' : 'active'}`}>
					<div
						className="d-m-block close-pop"
						onClick={() => {
							closePop();
						}}
					>
						<IconClose  />
					</div>
					{openIframe &&   <Iframe close={closePop} />}
					{isEmpty(qr) && !loading && <OfferBanner />}
					{!isEmpty(qr) && !loading && (
						<>
							<QrCode qrcode={qr} setTimeover={setTimeover} resp={responce} close={closePop} />
						</>
					)}
				</div>

				{loading && <Loader />}
			</TabContentWrapper>
			{!isEmpty(statusResp) && <AddMoneyReceipt data={statusResp} setData={setStatusResp} />}

			<>
				<form ref={formRef} method="POST" action="https://payments.airpay.co.in/pay/index.php" 
			//	target="paymentIframe"
				target="_blank"
				>
				<input type="hidden" name="privatekey" value={formData?.privateKey || ""} />
          <input type="hidden" name="mercid" value={formData?.merId || ""} />
          <input type="hidden" name="orderid" value={formData?.orderId || ""} />
          <input type="hidden" name="checksum" value={formData?.checksum || ""}/>
          <input type="hidden" name="currency" value={formData?.currency || ""}/>
          <input type="hidden" name="isocurrency" value={formData?.isoCurrency || ""} />
          <input type="hidden" name="buyerEmail" value={formData?.buyerEmail || ""} />
          <input type="hidden" name="buyerPhone" value={formData?.buyerPhone || ""} />
          <input type="hidden" name="buyerFirstName" value={formData?.buyerFirstName || ""} />
          <input type="hidden" name="buyerLastName" value={formData?.buyerLastName || ""} />
          <input type="hidden" name="buyerAddress" value={formData?.buyerAddress || ""} />
          <input type="hidden" name="buyerCity" value={formData?.buyerCity || ""} />
          <input type="hidden" name="buyerState" value={formData?.buyerState || ""} />
          <input type="hidden" name="buyerCountry" value={formData?.buyerCountry || ""} />
          <input type="hidden" name="buyerPinCode" value={formData?.buyerPinCode || ""} />
          <input type="hidden" name="amount" value={formData?.amount || ""} />
          <input type="hidden" name="mer_dom" value={formData?.mer_dom || ""} />
				</form>
			</>
		</>
	);
}

const QrCode = ({ qrcode, setTimeover, resp, close = () => {} }) => {
	return (
		<>
			<QeWrapper className="qrWeapper flex">
				<div className="">
					<div className="flex header">
						<div className="close" onClick={close}>
							<IconClose />
						</div>
					</div>

					<div className="maiBox">
						<div className="left-box">
							<h3>Scan QR code to make a payment.</h3>
							<div className="img">
								<img className="logoImg" src={logo} />
								<img src={`data:image/png;base64,${qrcode}`} alt="pay with qr" />
							</div>
							<div className="flex timerBox">
								<span>Checking payment status…</span> <Timer setTimeover={setTimeover} time={300} />
							</div>
							<div class="loaderPending"></div>
						</div>
						<div className="right-box text-center">
							<p style={{ fontSize: '10px' }}>Pay with any Payment App</p>

							<img src={payIcons} alt="icons" />
							<a className="button-outline" href={resp?.upiUrl} style={{ padding: '8px 20px', display: 'block', marginInline: 'auto', width: '300px' }}>
								{' '}
								Pay With UPI
							</a>
						</div>
					</div>
					<div className="bottom"></div>
				</div>
			</QeWrapper>
		</>
	);
};
